// ANGULAR
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
// LIBS
import { Observable, throwError, BehaviorSubject, finalize } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { switchMap, filter, take } from 'rxjs/operators';
// SERVICES
import { AuthenticationConfigurationService } from '@services/authentication/authentication-configuration.service';
import { AuthenticationService } from '@services/authentication/authentication.service';
// MODELS
import { User } from '@models/authentication/User';
import { AlertService } from '../services/notification/alert.service';
import { SpinnerService } from '@services/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private authenticationService: AuthenticationService,
    private authConfigService: AuthenticationConfigurationService,
    private alertService: AlertService,
    private spinnerService: SpinnerService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && request.url.includes('/login')) {
          return next.handle(request);
        } else if (err.status === 401 &&
          !request.url.includes('/login') &&
          !request.url.includes('/refresh')) {
          return this.handle401Error(request, next);
        }
        return throwError(() => err);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.refreshTokenInProgress) {
      this.refreshTokenInProgress = true;
      this.refreshTokenSubject.next(null);
      return this.authenticationService.refreshToken()
      .pipe(
        switchMap((data: User) => {
          this.refreshTokenInProgress = false;
          this.refreshTokenSubject.next(data.accessToken);
          let requestWithToken = this.addTokenToRequest(request, data.accessToken);
          return next.handle(requestWithToken);
        }),
        catchError((error: any) => {
          this.authConfigService.clear();
          this.alertService.showSmallInfo('Sesión finalizada');
          this.refreshTokenSubject.error(error)
          return this.handleError(error);
        }),

      );
    }

    return this.refreshTokenSubject
    .pipe(
      filter((accessToken: string) => accessToken != null),
      take(1),
      switchMap((accessToken: string) => {
        let requestWithToken = this.addTokenToRequest(request, accessToken);
        return next.handle(requestWithToken);
    })).pipe(
      finalize(() => this.spinnerService.hide())
    );
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });
  }

  // ERROR GLOBAL DIFFERENT TO OTHERS ERRORS
  private handleError(errorResponse: HttpErrorResponse): Observable<never> {
    let errorMsg: string;
    console.log(JSON.stringify(errorResponse.error));
    if (errorResponse.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMsg = "An error occured : " + errorResponse.error.message;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMsg = `Backend returned code ${errorResponse.status}, body was: ${errorResponse.error}`;
    }
    return throwError(() => errorMsg);
  }
}